<script setup lang="ts">
import { getPrivacyPolicyUrl, getTermsOfUseUrl, getInfoPreferencesUrl } from '@/config/tcpa'

const privacyUrl = getPrivacyPolicyUrl()
const termsUrl = getTermsOfUseUrl()
const infoPrefsUrl = getInfoPreferencesUrl()
</script>

<template>
  <footer class="bg-white border-t border-gray-200 px-4 py-3 safe-area-bottom">
    <div class="flex items-center justify-center gap-4 text-xs text-gray-500">
      <a
        :href="privacyUrl"
        target="_blank"
        rel="noopener"
        class="hover:text-primary transition-colors"
      >
        Privacy Policy
      </a>
      <span class="text-gray-300">|</span>
      <a
        :href="termsUrl"
        target="_blank"
        rel="noopener"
        class="hover:text-primary transition-colors"
      >
        Terms of Use
      </a>
      <span class="text-gray-300">|</span>
      <a
        :href="infoPrefsUrl"
        target="_blank"
        rel="noopener"
        class="hover:text-primary transition-colors"
      >
        Information Preferences
      </a>
    </div>
  </footer>
</template>

<style scoped>
.safe-area-bottom {
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
}
</style>
